import React from 'react';
import { ShieldCheck, Truck, RefreshCcw } from 'lucide-react';
import ScrollReveal from '../common/ScrollReveal';

const FeaturesSection = () => {
  const features = [
    {
      icon: ShieldCheck,
      title: "100% Authentic",
      desc: "Genuine Apple products with full warranty."
    },
    {
      icon: Truck,
      title: "Fast Delivery",
      desc: "Immediate dispatch on all available stock."
    },
    {
      icon: RefreshCcw,
      title: "Device Trade-In",
      desc: "Upgrade your tech with our trade-in offers."
    }
  ];

  return (
    <section className="bg-white py-20 md:py-28 relative overflow-hidden">
      {/* Ambient accent */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-orange-500/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-6 relative">
        <ScrollReveal>
          <div className="text-center mb-14 md:mb-20">
            <span className="inline-block text-orange-500 text-xs font-bold tracking-[0.25em] uppercase mb-4">
              The iSeries Promise
            </span>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-[#1d1d1f]">
              Why Buy From Us?
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {features.map((item, i) => (
            <ScrollReveal key={i} delay={i * 120}>
              <div className="group relative h-full bg-gradient-to-b from-[#fbfbfd] to-white rounded-[1.75rem] p-8 md:p-10 text-center border border-gray-100 transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] hover:-translate-y-2 hover:shadow-[0_28px_56px_-20px_rgba(0,0,0,0.18)] hover:border-gray-200/80">
                {/* Icon tile */}
                <div className="relative w-16 h-16 mx-auto mb-7">
                  <div className="absolute inset-0 bg-orange-500/20 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="relative w-full h-full bg-gradient-to-br from-[#1d1d1f] to-black rounded-2xl flex items-center justify-center shadow-[0_10px_24px_-8px_rgba(0,0,0,0.5)] transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-3">
                    <item.icon className="w-7 h-7 text-white transition-colors duration-500 group-hover:text-orange-400" strokeWidth={1.5} />
                  </div>
                </div>

                <h3 className="text-xl font-bold text-[#1d1d1f] mb-3 tracking-tight">
                  {item.title}
                </h3>
                <p className="text-[15px] text-gray-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
